import React, { useEffect, useState } from 'react'
import PartnerHeader from './PartnerHeader'
import { Banner, CardBox, PartnerContainer } from '../../style/partnerStylemain'
import banner from '../../img/partnerBanner.png';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { AlertContainer, alert } from 'react-custom-alert'
import { useDispatch, useStore } from 'react-redux';
import { NOT_FOUND_LABEL } from '../../api/label';
import PartnerLoadingModal from './PartnerLoadingModal';
import CircularProgress from '@material-ui/core/CircularProgress';
import CancelIcon from '@material-ui/icons/Cancel';
import { useParams } from 'react-router-dom';
import { partnerVerifyEmail } from '../../store/publicPartner/action';
type Props = {}

const PartnerThankyouVerifyEmail = (props: Props) => {
    const [init, setInit] = useState(0);
    const store = useStore();
    const [error,setError] = useState();
    const dispatch = useDispatch();
    let { userKey } = useParams<{ userKey: string }>();
    let { refCode } = useParams<{ refCode: string }>();
    let { otp } = useParams<{ otp: string }>();
    useEffect(() => {
        const unsubscribe = store.subscribe(() => {
            var res = store.getState().SearchReducer;
            if (res.isLoading) {
            } else if (res.isLoaded) {
                if (res.data != null) {
                    if (res.table === "partner-verify-email") {
                        setInit(1);
                    }

                } else {
                    alert({ message: NOT_FOUND_LABEL, type: 'error' });
                }
            } else if (res.isNotFound) {
                alert({ message: NOT_FOUND_LABEL, type: 'error' });
            } else if (res.isFailed) {
                alert({ message: res.data.message, type: 'error' });
                setInit(1);
                setError(res.data.message)
            }
        });
        dispatch(partnerVerifyEmail(userKey,refCode,otp))
    },[])
    return (
        <div className='bg-light-gray partner-page' style={{ height: "100vh", fontFamily: "DB Helvethaica" }}>
            <div style={{ position: 'sticky', top: 0 }}>
                <div className="student-wrapper-header-inner" style={{ background: "#38383D" }}>
                    <PartnerHeader />
                </div>
            </div>
            <PartnerContainer className='mt-5'>
                <Banner src={banner}></Banner>
                <h2 className='text-center mt-3' ><br /></h2>
                <CardBox>
                    {init == 1 && !error && (
                        <>
                            <div className='text-center'>
                                <CheckCircleIcon className='my-4' style={{ fontSize: 80, color: "#53a451" }} />
                            </div>
                            <div className='text-center' style={{ fontSize: 22 }}>
                                e-Mail ของท่านได้รับการยืนยันเรียบร้อย
                            </div>
                        </>

                    )}
                    {init == 0 && (
                        <>
                            <div className='text-center'>
                                <div className='d-flex flex-column'>
                                    <div className='text-center' style={{ paddingBlock: 40 }}><CircularProgress style={{ 'color': '#628395' }} size="80px" /></div>
                                </div>
                            </div>
                            <div className='text-center' style={{ fontSize: 22 }}>
                                e-Mail ของท่านได้รับการยืนยันเรียบร้อย
                            </div>
                        </>
                    )}
                    {error && (
                        <>
                        <div className='text-center'>
                            <CancelIcon className='my-4' style={{ fontSize: 80, color: "#f24726" }} />
                        </div>
                        <div className='text-center' style={{ fontSize: 22 }}>
                            {error}
                        </div>
                    </>
                    )}

                </CardBox>
            </PartnerContainer>
        </div>
    )
}

export default PartnerThankyouVerifyEmail